import { useSetRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Paper, TextField } from '@mui/material';
import { toast } from 'material-react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { selectedPageAtom } from '../../atoms/Page';
import { PageType } from '../../interfaces/AdminPage';
import { isTokenValid, storeToken } from '../../utils/Auth';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { login } from '../../api/Auth';

export const LoginPage = () => {
  const navigate = useNavigate();

  const setSelectedPage = useSetRecoilState(selectedPageAtom);

  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [maskPassword, setMaskPassword] = useState(true);

  useEffect(() => {
    setSelectedPage(PageType.LOGIN);
    if (isTokenValid()) {
      navigate('/');
    }
  }, []);

  const handleLogin = () => {
    setLoading(true);
    login(username, password)
      .then((token) => {
        storeToken(token);
        navigate('/');
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => setLoading(false));
  };

  const handleChangeUsername = (e: any) => {
    setUsername(e.target.value as string);
  };

  const handleChangePassword = (e: any) => {
    setPassword(e.target.value as string);
  };

  const handleTextFieldKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      handleLogin();
    }
  };

  return (
    <Box
      component='div'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Waiting open={loading} />
      <Paper sx={{ p: 3, width: 250 }}>
        <Box component='div' sx={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            size='small'
            label='Kullanıcı Adı / E-Posta'
            value={username}
            sx={{ marginBottom: 1.5 }}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeUsername}
            onKeyDown={handleTextFieldKeyDown}
          />
          <TextField
            size='small'
            label='Şifre'
            value={password}
            sx={{ marginBottom: 1.5 }}
            type={maskPassword ? 'password' : undefined}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  size='small'
                  color='primary'
                  onClick={() => setMaskPassword((x) => !x)}
                >
                  {maskPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              ),
            }}
            onChange={handleChangePassword}
            onKeyDown={handleTextFieldKeyDown}
          />
          <Button
            color='primary'
            size='small'
            variant='contained'
            disabled={!username || !password}
            onClick={handleLogin}
            sx={{
              ...sharedStyles.buttonText,
              display: 'flex',
              width: 'auto',
            }}
          >
            Giriş
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
